import { getLegionExpose } from "src/api/Admin";

export interface LegionExposeData{
    wide_loc: string,
    total_school_count: number,
    total_student_count: number,
    current_promoted_school_count: number,
    current_promoted_student_count: number,
    prev_year_promoted_school_count :number,
    prev_year_promoted_student_count :  number
}

export const LoadLegionExpose = async (start_date: string|null, end_date: string|null)=>{
    const response = await getLegionExpose(start_date,end_date)
    
    return response.data as LegionExposeData[]
}